(function($){

	$(document).ready(function(){

		$(document).on('click','#site-header .search-trigger',function(e){
			e.preventDefault();
			$search_active = $('#site-header .search-form').hasClass('active');

			if($search_active) {
				$('#site-header .search-form').submit();
			} else {
				$('#site-header').addClass('search-active');
				$('#site-header .search-form').addClass('active');
				$('#site-header .search-form input[name="s"]').focus();
			}
		});

		$(document).click(function(e) {
			console.log(e.target);
			$is_search = e.target.classList.contains('search-form') || e.target.classList.contains('search-trigger') || e.target.classList.contains('search-field');

			if($(window).width() > 991 && !$is_search) { 
				$('#site-header').removeClass('search-active');
				$('#site-header .search-form').removeClass('active');
			} 

		});

	});
	
})(jQuery);